import type {User, UserWithTasks} from './users'
import { ID } from '../types/UtilityTypes'

export interface Department {
    id: ID,
    title: string,
    active: boolean,
    statistics_active: boolean,
}

export const EMPTY_DEPARTMENT: Department = {
    id: 0,
    title: '',
    active: true,
    statistics_active: true,
}
export interface Departments extends Department {
    users: User[]
}
export interface DepartmentWithUsers extends Department {
    users: UserWithTasks[],
}